/**
 * 活动公用的css类名
 */
export const ACT_CSS_CLASSES = {
  /**
   * 滚动时隐藏
   */
  scrollHide: 'act-scroll-hide',

  /**
   * 水平居中
   */
  horizontalCenter: '_horizontal-center',

  /**
   * 垂直居中
   */
  verticalCenter: '_vertical-center',

  /**
   * 禁用
   */
  disabled: 'disabled',
};

/**
 * 组件名前缀
 */
export const COMPONENT_PREFIX = 'iwan-act-comp';

/**
 * 页面宽度
 */
export enum EPageWidth {
  /**
   * tv 类型的页面宽度
   */
  tv = 1920,
  /**
   * 常规页面宽度
   */
  normal = 375
};

export const COMP_DEFAULT_BACKGROUND_IN_EDITOR = 'rgba(51, 153, 255, 0.5)';

export const COMP_DEFAULT_FIXED_ZINDEX_IN_EDITOR = 500;

/**
 * 组件渲染模式
 *
 * #### 默认模式 `ERenderType.DEFAULT`，值为 1
 * 表现为组件配置中 `ERenderType.DEFAULT`，在渲染时，会对组件做如下操作：
 *  - 注入 `vmApi`
 *  - 处理配置的 `display` 配置，用来控制组件的显隐
 *  - 处理配置中的 `style` 配置，并设置到组件的根节点的 `style` 属性上
 *  - 处理配置的的 `className` 配置，并设置组件的根节点上
 *  - 在组件的生命周期函数中执行配置中对应的生命周期函数配置，例如在组件 `created` 中执行配置中的 `created` 函数
 *  - 组件在编辑器中的配置中自动加入高级的配置 `tab`
 *  - 处理配置的 `report` 配置，对组件进行曝光点击上报
 *  - 自动将组件的 `id` 属性设置为配置中 `id`
 *
 * ### 自定义模式 `ERenderType.CUSTOM`，值为 0
 * 组件将按照正常的方式渲染，平台不会对其做任何的干预
 * 需要自己再组件的根节点上设置 `id` 属性为配置中的 `id`，在编辑器中的选中行为是根据 `dom` 上有没有 `id` 来区分的
 *
 * 原魔方文档链接: [渲染模式](https://iwiki.woa.com/pages/viewpage.action?pageId=425259705)
 *
 */
export enum ERenderType {
  /**
   * 自定义模式
   *
   * 组件将按照正常的方式渲染，平台不会对其做任何的干预
   * 需要自己再组件的根节点上设置 `id` 属性为配置中的 `id`，在编辑器中的选中行为是根据 `dom` 上有没有 `id` 来区分的
   */
  CUSTOM = 0,

  /**
   * 默认渲染模式
   *
   * 表现为组件配置中 `ERenderType.DEFAULT`，在渲染时，会对组件做如下操作：
   *  - 注入 `vmApi`
   *  - 处理配置的 `display` 配置，用来控制组件的显隐
   *  - 处理配置中的 `style` 配置，并设置到组件的根节点的 `style` 属性上
   *  - 处理配置的的 `className` 配置，并设置组件的根节点上
   *  - 在组件的生命周期函数中执行配置中对应的生命周期函数配置，例如在组件 `created` 中执行配置中的 `created` 函数
   *  - 组件在编辑器中的配置中自动加入高级的配置 `tab`
   *  - 处理配置的 `report` 配置，对组件进行曝光点击上报
   *  - 自动将组件的 `id` 属性设置为配置中 `id`
   */
  DEFAULT = 1,
}
